export default __webpack_public_path__ + "static/media/ipark-logo.2cbb9eef.png";